module.exports = __webpack_public_path__ + "img/uid-popup-hen.c0c45f88.png";